import React from "react";

const StatsBar = ({ name, score, isActive, onClick }) => {
  const containerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "0.3vw",
  };

  const nameStyle = {
    marginRight: "1vw",
    textAlign: "center",
  };

  const barContainerStyle = {
    flex: 1,
    position: "relative",
  };

  const maxScore = 100;

  const barStyle = {
    width: `${score / maxScore}%`,
    backgroundColor: "green",
    height: "2vh",
    position: "relative",
  };

  console.log(score);

  const scoreContainerStyle = {
    paddingLeft: "5px",
    marginLeft: "5px",
    minWidth: "50px",
    fontSize: "12px",
  };

  return (
    <div style={containerStyle}>
      <div style={nameStyle}>
        <button
          className={`Setting_Select_Button ${isActive ? "active" : ""}`}
          onClick={onClick}
          style={{
            width: "5vw"
          }}
        >
          {name}
        </button>
      </div>
      <div style={barContainerStyle}>
        <div
          style={{
            width: "100%",
            backgroundColor: "#ddd",
          }}
        >
          <div style={barStyle}></div>
        </div>
      </div>
      <div
        style={
          isActive
            ? { ...scoreContainerStyle, fontWeight: "bold" }
            : scoreContainerStyle
        }
      >
        {(score / 100).toFixed(2)}
      </div>
    </div>
  );
};

export default StatsBar;
